export const nav = {
  home: "Witamy",
  howItWorks: "Jak to działa",
  discover: "Odkrywaj",
  explore: "Eksploruj",
  exploreDesc: "Odkrywaj członków i miejsca docelowe",
  destinations: "Miejsca docelowe",
  destinationsDesc: "Przeglądaj dostępne miejsca docelowe",
  membersMap: "Mapa członków",
  membersMapDesc: "Znajdź członków w pobliżu",
  pricing: "Ceny",
  dashboard: "Panel sterowania",
  dashboardDesc: "Zarządzaj ogłoszeniami i wymianami",
  mySpace: "Moja przestrzeń",
  myCalendar: "Mój terminarz",
  myCalendarDesc: "Zarządzaj kalendarzem i wymianami",
  incomingRequests: "Inteligentne dopasowanie",
  incomingRequestsDesc: "Otrzymane prośby i sugestie AI",
  favorites: "Ulubione",
  favoritesDesc: "Twoje ulubione miejsca docelowe",
  messaging: "Wiadomości",
  messagingDesc: "Rozmowy i propozycje",
  login: "Zaloguj się",
  signup: "Zarejestruj się",
  corporate: "Firma",
  announcement:
    "DONKEY TRAVEL — europejski klub wymiany domów zarezerwowany dla gospodarzy Airbnb z oceną 4,5 i wyższą",
};
